import { useEffect } from "react";

const SITE = "https://esprithomecare.com";

export function useSEO({ title, description, canonical }) {
  useEffect(() => {
    const p = canonical || (typeof window !== "undefined" ? window.location.pathname : "/");
    const url = `${SITE}${p}`;
    if (title) document.title = title;

    const setMeta = (selector, attr, value) => {
      if (!value) return;
      let tag = document.querySelector(selector);
      if (tag) tag.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:url"]', "content", url);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
    window.scrollTo(0, 0);
  }, [title, description, canonical]);
}

